import { render, staticRenderFns } from "./EditLayout.vue?vue&type=template&id=5adaa2ad&scoped=true"
import script from "./EditLayout.vue?vue&type=script&lang=js"
export * from "./EditLayout.vue?vue&type=script&lang=js"
import style0 from "./EditLayout.vue?vue&type=style&index=0&id=5adaa2ad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adaa2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5adaa2ad')) {
      api.createRecord('5adaa2ad', component.options)
    } else {
      api.reload('5adaa2ad', component.options)
    }
    module.hot.accept("./EditLayout.vue?vue&type=template&id=5adaa2ad&scoped=true", function () {
      api.rerender('5adaa2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/EditLayout.vue"
export default component.exports